<template>
  <div class="my-org">
    <div class="step2">
       <div class="step2-box">
          <h2>备案承诺申明</h2>
          <p class="step2-p1"> 本单位承诺，办理{{message}}备案手续的拟备案信息真实、完整、准确，符合法律法规，声明对其填报内容和提交资料的真实性、合法性、准确性、完整性负责，若本单位违反承诺错误备案、虚假备案、恶意备案，由此产生的一切后果，由本申报单位自行承担。</p>
          <p class="step2-p2">
            <template>
              <el-checkbox v-model="checked" @change="changecuk" class="color-red">本单位同意以上备案承诺申明全部内容</el-checkbox>
            </template>
          </p>
       </div>
    </div>
  </div>
</template>
<script>
import weather from "../../data/emer/weather.js";
export default {
  props: {
    message: String,
    state: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      seenone: false,
      seentwo: false,
      checked: false,
    }
  },
  created() {
    this.checked = this.state
  },
  methods: {
    // 阅读协议
    changecuk() {
       this.$emit('change', this.checked)
    },
  },
}

</script>
<style lang="stylus" scoped>
.step-box {
  text-align: center;
  margin-top: 30px;
}

.step2 {
  width: 700px;
  margin: 50px auto;

  h2{
    text-align:center
  }
  .step2-p1{
    margin-top:30px;
    font-size:16px;
    line-height:30px
    text-indent: 2em;
  }
  .step2-p2{
    margin-top:10px;
        position: absolute;
    bottom: 28px;
  }
}
.step2-box{
  position:relative;
  box-sizing: border-box;
  border:solid 1px #ddd;
  padding: 40px 60px 80px 60px;
      box-shadow: 3px 3px 1px #f7f3f3;
    border-radius: 5px;
}
  .org-control {
    width: 200px;
    margin: 20px auto;
  }
.color-red {
  color:red;
}
</style>



// WEBPACK FOOTER //
// comfirmFile.vue?3a19ece5